import dexian_logo from '../../../assets/images/dexian.jpeg'
import ac_logo from '../../../assets/images/avenue_code.webp'
import extranet_logo from '../../../assets/images/extranet_logo.jpeg'
import ch_logo from '../../../assets/images/ch_logo.jpeg'
import TimelineItem from '../../atoms/timelineItem';
import experiences from '../../../data/experiences.json';

import './style.css'

function Timeline() {

    const logos = {
        dexian: dexian_logo,
        avenue_code: ac_logo,
        extranet: extranet_logo,
        ch_master_data: ch_logo
    }

    return(
        <div className='timeline'>
            {experiences.experiences.map((experience) => (
                <TimelineItem 
                    key={experience.id}
                    logo={logos[experience.id]} 
                    role={experience.role} 
                    date={experience.date} 
                    company={experience.company} 
                    text={experience.text} 
                    techs={experience.techs}
                />
            ))}
        </div>
    )
}

export default Timeline;